import PropTypes from 'prop-types'

import { OperationStatus, ReviewStatus } from 'features/Codes'
import OperationStatusDisplay from 'features/shared/OperationStatusDisplay'
import { isPresent } from 'utils'
import Button from 'components/form/Button'
import { useDialog } from 'features/dialog/Dialog'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import Join from 'components/Join'

const ChannelOperationStatus = ({
  isPaused,
  pausedReason,
  isDisabled,
  reviewStatus,
}) => {
  const negativeStatus = [
    isPaused && OperationStatus.OFF_BY_BIZ_CHANNEL_ADMIN,
    reviewStatus !== ReviewStatus.APPROVED &&
      OperationStatus.APPROVING_OR_REJECTED,
    !isPaused &&
      isDisabled &&
      reviewStatus === ReviewStatus.APPROVED &&
      OperationStatus.OFF_BY_BIZ_CHANNEL_TALK_CHANNEL_VIEW,
  ].filter(Boolean)
  const [AdminPauseReason, show, hide] = useDialog()
  return (
    <>
      <OperationStatusDisplay
        operationStatus={
          isPresent(negativeStatus) ? negativeStatus : [OperationStatus.ON]
        }
      />
      {pausedReason && (
        <>
          <div className="wrap_btn">
            <Button size="small" onClick={show}>
              관리자정지 사유
            </Button>
          </div>
          <AdminPauseReason type="basic_layer" className="reason_layer">
            <ConfirmModal
              title="관리자정지 사유확인"
              handleClose={hide}
              showCancelBtn={false}>
              <ul className="list_append">
                <li>
                  <Join divider={<br />}>{pausedReason.split('\n')}</Join>
                </li>
              </ul>
            </ConfirmModal>
          </AdminPauseReason>
        </>
      )}
    </>
  )
}

export default ChannelOperationStatus

ChannelOperationStatus.propTypes = {
  isPaused: PropTypes.bool,
  pausedReason: PropTypes.string,
  isDisabled: PropTypes.bool,
  reviewStatus: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
  }),
}
